import AgapeTypography from './AgapeTypography';

import HeadingSectionTypography from './components/HeadingSectionTypography';
import AgapeTextField from '../textfield/AgapeTextField';
import HeadingTitleTypography from './components/HeadingTitleTypography';
import MiddleText from './components/MiddleText';
import MutedTypography from './components/MutedTypography';
import QuoteTypography from './components/QuoteTypography';

export {
  HeadingSectionTypography,
  AgapeTextField,
  HeadingTitleTypography,
  MiddleText,
  MutedTypography,
  QuoteTypography,
};

export default AgapeTypography;
